import 'regenerator-runtime/runtime'
import useBSSLogger from '../hooks/useBSSLogger';
import getapiclient, { getwpclient } from '../lib/ajaxhelper';
import { defaultGridCfg, grid } from './std';
import saveAs from 'file-saver';

const {logger} = useBSSLogger();

/**
 * Richiamato da MenuCarrello da ogni pagina 
 * Si occupa di cercare un carrello dall'header authorization
 * Se non presente cerca il carrello per header BSS-CLIENTSESSIONID
 * Se non presente crea un carrello vuoto 
 * Quindi ritorna sempre un carrello anche se vuoto
 * 
 * @returns 
 */
const previousCart = async () => {

    const {data} = await getapiclient().get(`carrello/userscart`)

    logger.debug("ottengo il carrello", data);

    return data; 
}

/**
 * Ricevuto il carrello, lo associa all'anagrafica o alla sessione client.
 * Se per la stessa sessione client o anagrafica esiste un carrello in stato I va in modifica.
 * In presenza di anagrafica la sessione client viene ignorata.
 * Se il carrello è valido e pagato viene creato un ordine.
 * Viene richiamato allo step 3 e allo step 4. Solo allo step 4 vengono passati i pagamenti e i dati di fatturazione
 * Il webservice torna il carrello indicando per ogni preventivo la validità.
 * 
 * 
 * @param {*} req 
 * @returns 
 */
const orderFromCart =  async (req) => {

    const {idmodpag, ...resto} = req;

    const {data} = await getapiclient().post(`testataordine/createcartandorders`, {
        jsonobject: JSON.stringify(resto),
        idmodpag
    })

    logger.debug("creo ordine dal carrello");

    return data;  
}

const createEditCart =  async (req) => {

    const {data} = await getapiclient().post(`carrello/createEditCart`, {
        jsonobject: JSON.stringify(req)
    })

    logger.debug("creo o modifico il carrello", req, data);

    return data;  
}

/**
 * INUTILIZZATO
 * 
 * @param {*} req 
 * @returns 
 */
const saveCart =  async (req) => {

    const {data} = await getapiclient().post(`carrello/createcart`, {
        jsonobject: JSON.stringify(req)
    })

    logger.debug("salvo il carrello", req, data);

    return data;  
}

/**
 * INUTILIZZATO
 * Crea ordine dal carrello reperito dal token
 * 
 * @param {*}  
 * @returns 
 */
const orderFromCartImplicit =  async () => {

    const {data} = await getapiclient().post(`testataordine/createorderfromcart`)

    logger.debug("creo ordine dal carrello");

    return data;  
}

const orderDetail =  async (idordine) => {

    const {data} = await getapiclient().post(`testataordine/findinfotesutente`, {
        id: idordine
    })

    logger.debug("trovate info aggiuntive sull'ordine", data);

    return data;  
}

const usersOrders = async (cfg) => {
    const data = await grid('testataordine', cfg, "testataordine/gridutente")

    return data;
}

const orderStates = async (cfg = defaultGridCfg) => {
    const data = await grid('statiordine', cfg)

    return data;
}

const orderDocs = async (idto) => {
    const data = await getapiclient().post("testataordine/documenti", {
        idto
    })
}

const documentDownload = async (iddoc, idtipodoc) => {

    logger.debug("chiamata ajax documentDownload", iddoc, idtipodoc)

    // try {
        const data = await getapiclient().post("testatafattura/stampa", {
            iddoc,
            idtipodoc
        }, {
            downloadCfg: {
                name: `${iddoc}.pdf`
            }
        })

        return data;
    // } catch(err){
    //     logger.debug("errore chiamata ajax documentDownload", iddoc, idtipodoc, err)
    // }
    

}

const genFatt = async (idtestataordine, idsezionale = undefined, dataemissione = undefined) => {

    let body = {       
        idtestataordine
    }

    if(![null, undefined].includes(idsezionale)){
        body = {
            ...body,
            idsezionale
        }
    }

    if(![null, undefined].includes(dataemissione)){
        body = {
            ...body,
            dataemissione
        }
    }

    const data = await getapiclient().post("testatafattura/created", body)
}

const info = async () => {

    const data = await getapiclient().get("testataordine/info")

    return data;

}

const gridEventi = async () => {
    const data = await grid("storicoeventi")

    logger.debug("eventi", data);
    
    return data;
}

export {orderFromCartImplicit, orderFromCart, saveCart, previousCart, createEditCart, usersOrders, orderStates, orderDetail, orderDocs, documentDownload, genFatt, info, gridEventi}